import './Position.less';
import React, { useCallback, useContext } from "react";
import { Col, Row, Select, Slider } from "antd";
import { FileCenterContext, IFileCenterContext } from "@/common/components/FileCenterProvider";
import { isCustomPosition } from "@/common/utils/positionUtil";
import { postionOption, PositionType } from '@/common/constants/interfaces';

function Position() {
    const { position, setPosition } = useContext<IFileCenterContext>(FileCenterContext);
    const { positionType } = position

    const handlePositionTypeChange = useCallback((value: PositionType) => {
        setPosition({ ...position, positionType: value })
    }, [position, setPosition])

    const handleOffsetXChange = useCallback((value: number) => {
        setPosition({ ...position, offsetX: value })
    }, [position, setPosition])

    const handleOffsetYChange = useCallback((value: number) => {
        setPosition({ ...position, offsetY: value })
    }, [position, setPosition])

    return (
        <>
            <Row>
                <Col span={6} className='text'>
                    位置
                </Col>
                <Col span={18}>
                    <Select className="position-select" variant="filled" onChange={handlePositionTypeChange} value={positionType} options={postionOption} />
                </Col>

            </Row>
            {
                isCustomPosition(positionType) && (
                    <>
                        <Row>
                            <Col span={6} className='text'>
                                {positionType === PositionType.LeftTop ? '左' : '右'}边距离
                            </Col>
                            <Col span={18}>
                                <Slider
                                    min={0}
                                    max={500}
                                    step={5}
                                    onChange={handleOffsetXChange}
                                    value={position.offsetX}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={6} className='text'>
                                {positionType === PositionType.LeftTop ? '上' : '下'}边距离
                            </Col>
                            <Col span={18}>
                                <Slider
                                    min={0}
                                    max={500}
                                    step={5}
                                    onChange={handleOffsetYChange}
                                    value={position.offsetY}
                                />
                            </Col>
                        </Row>
                    </>
                )
            }

            {
                positionType === PositionType.Bottom && (
                    <Row>
                        <Col span={6} className='text'>
                            下边距离
                        </Col>
                        <Col span={18}>
                            <Slider
                                min={0}
                                max={500}
                                step={5}
                                onChange={handleOffsetYChange}
                                value={position.offsetY}
                            />
                        </Col>
                    </Row>
                )
            }
              {
                positionType === PositionType.Top && (
                    <Row>
                        <Col span={6} className='text'>
                            上边距离
                        </Col>
                        <Col span={18}>
                            <Slider
                                min={0}
                                max={500}
                                step={5}
                                onChange={handleOffsetYChange}
                                value={position.offsetY}
                            />
                        </Col>
                    </Row>
                )
            }

        </>
    );
}

export default React.memo(Position);